<template>
  <div class="week_report" v-if="clazz">
    <div class="rank_container bgwhite">
      <div class="header after_border">
        <div class="left" @click="onPrevDay">上一天</div>
        <compele-select v-model="filterMold" @confirm="onConfirm"/>
        <div class="right" @click="onNextDay">下一天</div>
      </div>
      <div class="after_border curr">
        {{currDayDisplay}}
      </div>

      <div class="rank_list">
        <template v-for="(item, index) in list">
          <day-stat-cell
            :key="index"
            v-if="checkShow(item)"
            :data="item"
            :is-manager="clazz.is_manager"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import CompeleSelect from '@/views/clazz/components/CompeleSelect'
import DayStatCell from '@/views/clazz/components/DayStatCell'
import { formatDate } from '@/utils/index'
import { clazzDayStat, clazzSimpleInfo } from '@/api/clazz'

export default {
  name: 'WeekReport',
  components: {
    CompeleSelect,
    DayStatCell
  },
  data () {
    return {
      clazzId: undefined,
      clazz: null,
      currDay: new Date(),
      filterMold: 'all',
      list: []
    }
  },
  computed: {
    currDayDisplay () {
      return formatDate(this.currDay)
    }
  },
  created () {
    this.clazzId = this.$route.params.clazz_id || ''
    this.getClazzInfo(this.clazzId)
    this.getStat()
  },
  methods: {
    async getClazzInfo (clazzId) {
      let response = await clazzSimpleInfo(clazzId)
      this.clazz = response.data
    },
    async getStat () {
      let response = await clazzDayStat(this.clazzId, { day: this.currDayDisplay })
      this.list = response.data
    },
    onPrevDay () {
      this.currDay = new Date(this.currDay.getTime() - 86400000)
      this.getStat()
    },
    onNextDay () {
      this.currDay = new Date(this.currDay.getTime() + 86400000)
      this.getStat()
    },
    checkShow (item) {
      if (this.filterMold === 'all') {
        return true
      }
      if (this.filterMold === 'competed' && item.is_complete) {
        return true
      }
      if (this.filterMold === 'uncompeted' && !item.is_complete) {
        return true
      }
      return false
    },
    onConfirm () {
    }
  }
}
</script>

<style scoped lang="scss">
.week_report{
  .rank_container {
    .header {
      padding: 30px 20px 30px 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 26px;
    }
    .curr {
      text-align: center;
      font-size: 26px;
      padding: 20px 0;
    }
  }
}
</style>
